import React from 'react';
import { Link } from 'gatsby';
import { useSelector, useDispatch } from 'react-redux';
import { FiChevronDown } from 'react-icons/fi';
import { useLocation } from '@reach/router';
import classnames from 'classnames';

import { IApplicationState } from '../../../store';
import * as layoutActions from '../../../store/layout/actions';

import './header.styles.scss';

const Header = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const collapsed = useSelector(
    (state: IApplicationState) => state.layout.collapsedNavbar
  );
  const headerElRef = React.useRef<HTMLHeadingElement>(null);

  const toggleNavbar = () => {
    dispatch(layoutActions.setCollapsibleNavbar());
  };

  React.useEffect(() => {
    document.addEventListener('scroll', () => {
      if (headerElRef && headerElRef.current) {
        if (window.scrollY > 170) {
          headerElRef.current.classList.add('is-sticky');
        } else {
          headerElRef.current.classList.remove('is-sticky');
        }
      }
    });
  }, []);

  return (
    <header>
      <div ref={headerElRef} className="navbar-wrapper">
        <div className="tarn-nav">
          <div className="container-fluid">
            <nav className="navbar navbar-expand-lg navbar-light">
              <Link to="/" onClick={toggleNavbar} className="navbar-brand">
                <img
                  src={require('../../../assets/photos/logo.png')}
                  alt="logo"
                />
              </Link>

              <button
                onClick={toggleNavbar}
                className={classnames('navbar-toggler', { collapsed })}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="icon-bar top-bar"></span>
                <span className="icon-bar middle-bar"></span>
                <span className="icon-bar bottom-bar"></span>
              </button>

              <div
                className={classnames('collapse', 'navbar-collapse', {
                  show: !collapsed,
                })}
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link to="/" activeClassName="active" className="nav-link">
                      Home
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      to="/offerings"
                      activeClassName="active"
                      className="nav-link"
                    >
                      Offerings
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      to="#"
                      onClick={(e) => e.preventDefault()}
                      className={classnames('nav-link', {
                        active:
                          location.pathname === '/blog' ||
                          location.pathname === '/in-the-news',
                      })}
                    >
                      News <FiChevronDown />
                    </Link>

                    <ul className="dropdown-menu">
                      <li className="nav-item">
                        <Link
                          to="/in-the-news"
                          activeClassName="active"
                          onClick={toggleNavbar}
                          className="nav-link"
                        >
                          In The News
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/blog"
                          activeClassName="active"
                          onClick={toggleNavbar}
                          className="nav-link"
                        >
                          Blog
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/who-we-are"
                      activeClassName="active"
                      onClick={toggleNavbar}
                      className="nav-link"
                    >
                      Who We Are
                    </Link>
                  </li>
                </ul>

                <div className="others-option d-flex align-items-center">
                  <div className="option-item">
                    <form className="search-box">
                      <input
                        type="text"
                        className="input-search"
                        placeholder="Finder for Hopin"
                      />
                      <button type="submit">
                        <i className="flaticon-loupe"></i>
                      </button>
                    </form>
                  </div>

                  <div className="option-item">
                    <Link
                      to="/contact"
                      activeClassName="active"
                      onClick={toggleNavbar}
                      className="default-btn"
                    >
                      {/* span is used for on hover animation */}
                      <i className="flaticon-calendar"></i>
                      Get in Touch <span></span>
                    </Link>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
